import { ModalBottomButtons, TextArea } from '@bp/ui-components';
import { Form, Formik, FormikHelpers } from 'formik';
import { useActivityProtocol } from 'hooks/matrix/useActivityProtocol';
import { useTranslation } from 'react-i18next';
import { NotificationReason } from 'utils/matrixClient';

type SubmissionEditRequestFormType = {
  reason: string | null;
};

type SubmissionEditRequestFormProps = {
  submissionUuid: string;
  onLoading: (loading: boolean) => void;
  onClose: () => void;
};

export const SubmissionEditRequestForm = ({ submissionUuid, onLoading, onClose }: SubmissionEditRequestFormProps) => {
  const { t } = useTranslation();

  const { sendMessage } = useActivityProtocol();

  const initialValues: SubmissionEditRequestFormType = {
    reason: null,
  };

  async function handleSubmit(
    values: SubmissionEditRequestFormType,
    helpers: FormikHelpers<SubmissionEditRequestFormType>,
  ) {
    onLoading(true);
    await sendMessage(submissionUuid, NotificationReason.SubmissionRequestToFeedback, values.reason);
    onLoading(false);
    helpers.resetForm();
    onClose();
  }

  return (
    <Formik<SubmissionEditRequestFormType> initialValues={initialValues} onSubmit={handleSubmit}>
      {({ setFieldValue, values }) => (
        <Form>
          <TextArea
            label={t('common.reason')}
            onChange={(e) => setFieldValue('reason', e.target.value)}
            value={values.reason ?? undefined}
            name='reason'
            rows={4}
            isScrollable
          />
          <ModalBottomButtons closeButton={{ callback: () => onClose() }} />
        </Form>
      )}
    </Formik>
  );
};
